import React from 'react'
export const arrayRemove = (arr, value) => {
  return arr.filter(function (ele) {
    return ele != value
  })
}
